import { Component, OnDestroy, OnInit } from "@angular/core";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { Moment } from "moment";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";

import { CotizacionDTO } from "../../shared/interfaces/cotizacion.interface";
import { CotizacionesService } from "../../shared/services/rest/cotizaciones.service";
import { DialogService } from "../../shared/services/rest/dialog.service";
import { NotificacionesService } from "../../shared/services/rest/notificaciones.service";
import { DialogActualizarVigenciaComponent } from "./components/dialog-actualizar-vigencia/dialog-actualizar-vigencia.component";

import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";

import * as _moment from "moment";
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from "moment";
import { ActivatedRoute } from "@angular/router";
import { FiltrosService } from "../../shared/services/util/filtros.service";
import { MenuUsuarioService } from "../../shared/services/util/menu-usuario.service";
import { ClienteService } from "../../shared/services/rest/cliente.service";
import { EstadoDTO } from "../../shared/interfaces/estado.interface";
import { ClienteDTO } from "../../shared/interfaces/cliente.interface";
const moment = _rollupMoment || _moment;

@Component({
    selector: "app-cotizaciones",
    templateUrl: "./cotizaciones.component.html",
    styleUrls: ["./cotizaciones.component.scss"],
})
export class CotizacionesComponent implements OnInit, OnDestroy {
    cotizaciones: CotizacionDTO[];
    subscripciones: Subscription;
    mostrarFiltros: boolean;
    setearFiltros: boolean;
    total: number = 0;
    clientes: ClienteDTO[];
    vigencias: EstadoDTO[];
    situaciones: EstadoDTO[];
    procesando: boolean = false;

    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _cotizacionesSrvc: CotizacionesService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _notificacionSrvc: NotificacionesService,
        private _dialogSrvc: DialogService,
        private activatedRoute: ActivatedRoute,
        private _filtroSrvc: FiltrosService,
        private _menuUsuarioSrvc: MenuUsuarioService,
        private _clienteSrvc: ClienteService
    ) {
        this._filtroSrvc.getFiltro("filtrosCotizaciones");
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);

        this.activatedRoute.queryParams.subscribe((queryParams) => {
            if (Object.entries(queryParams).length > 0) {
                this.setearFiltros = true;
                //console.log(queryParams);
                this.mostrarFiltros = true;
                //setear los filtros
                if (queryParams.situacion) {
                    this._filtroSrvc.setFiltro(
                        "filtrosCotizaciones",
                        "situacion",
                        queryParams.situacion,
                        queryParams.nombre
                    );
                }
                if (queryParams.vigencia) {
                    this._filtroSrvc.setFiltro(
                        "filtrosCotizaciones",
                        "vigencia",
                        queryParams.vigencia,
                        queryParams.nombreVigencia
                    );
                }
                //this._cotizacionesSrvc.cotizacionesRefresh$.next(true);
            } else {
                this.mostrarFiltros = false;
                this.setearFiltros = false;
            }
        });
    }

    ngOnInit(): void {
        this.buscarCotizaciones();

        if (this._menuUsuarioSrvc.esSupervisor()) {
            this._clienteSrvc
                .fetchClientes(0, "desc")
                .subscribe((resp) => (this.clientes = resp.content));
        } else {
            this.clientes = [];
        }

        this.situaciones = [
            { id: 0, descripcion: "Todos" },
            { id: 1, descripcion: "Cotizadas" },
            { id: 2, descripcion: "No cotizadas" },
        ];

        this.vigencias = [
            { id: 0, descripcion: "Todos" },
            { id: 1, descripcion: "Vigentes" },
            { id: 2, descripcion: "No Vigentes" },
        ];
    }

    buscarCotizaciones() {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._cotizacionesSrvc
                .fetchCotizaciones()
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((cotizaciones) => {
                    this.total = cotizaciones.totalElements;
                    this.cotizaciones = cotizaciones.content;
                    this._cotizacionesSrvc.onCotizacionChanged$.next(
                        cotizaciones
                    );
                })
        );
    }

    solicitarActualizacion(idCotizacion: number) {
        //console.log(idCotizacion);
        this.procesando = true;
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._cotizacionesSrvc
                .solicitaActualizacion(idCotizacion)
                .pipe(
                    finalize(() => {
                        this._fuseProgressBarService.hide();
                        this.procesando = false;
                    })
                )
                .subscribe((reps) =>
                    this._notificacionSrvc.mostrarNotificacion(
                        "Solicitud de actualización de cotización enviada",
                        "success"
                    )
                )
        );
    }

    actualizarVigencia(idCotizacion: number) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogActualizarVigenciaComponent,
            "clase-dialog",
            "600px"
        );

        dialogRef.afterClosed().subscribe((result: { fecha: Moment }) => {
            if (result) {
                this.subscripciones.add(
                    this._cotizacionesSrvc
                        .actualizaVigenciaCotizacion(
                            idCotizacion,
                            result.fecha.toISOString().split("T")[0]
                        )
                        .pipe(
                            finalize(() => this._fuseProgressBarService.hide())
                        )
                        .subscribe((reps) => {
                            this._cotizacionesSrvc.cotizacionesRefresh$.next(
                                true
                            );
                            this.buscarCotizaciones();
                            this._notificacionSrvc.mostrarNotificacion(
                                "Fecha de vigencia de cotización actualizada",
                                "success"
                            );
                        })
                );
            }
        });
    }

    filtrar(event) {
        //console.log(event);
        this._cotizacionesSrvc.resetPaginador();
        this._cotizacionesSrvc.cotizacionesRefresh$.next(true);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
